/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getReasonCodes } from '../fn/reason-codes/get-reason-codes';
import { GetReasonCodes$Params } from '../fn/reason-codes/get-reason-codes';
import { ReasonCode } from '../models/reason-code';

@Injectable({ providedIn: 'root' })
export class ReasonCodesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reasonCodeControllerGetReasonCodes()` */
  static readonly ReasonCodeControllerGetReasonCodesPath = '/reason-codes/{entityClass}/{entityId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReasonCodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReasonCodes$Response(
    params: GetReasonCodes$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<ReasonCode>>> {
    return getReasonCodes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReasonCodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReasonCodes(params: GetReasonCodes$Params, context?: HttpContext): Observable<Array<ReasonCode>> {
    return this.getReasonCodes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReasonCode>>): Array<ReasonCode> => r.body)
    );
  }
}
